module.exports = __webpack_public_path__ + "img/cart-pure-bg.f8cbe75e.jpg";